Pixlee.module('Entities', function(Entities, App, Backbone, Marionette, $) {
    Entities.Album = Entities.Model.extend({
        urlRoot: function() {
            return Routes.v2_albums_path();
        },
        defaults: {
            _ENTITY_NAME: 'album',
            // TODO (2020/08/28): public_viewing is deprecated, should remove references
            public_viewing: true,
            campaign: false,
            moderation: true,
            public_contribution: true,
            vote_interval: '1 day',
            title: '',
            description: '',
            notify_user_when_approved: false,
            has_default_action_link: false,
            regions: []
        },
        validation: {
            title: {
                required: true,
                minLength: 1
            },
            user_id: {
                required: true,
                pattern: 'number'
            },
            campaign: {
                required: true
            },
            moderation: {
                required: true
            },
            public_contribution: {
                required: true
            }
        },
        labels: {
            title: 'Album name'
        },
        isCategory: function() {
            return this.get('album_type') === 'category';
        },
        isProduct: function() {
            return this.get('album_type') === 'product';
        },
        isStandard: function() {
            return this.get('album_type') === 'standard';
        },
        isHome: function() {
            return this.get('album_type') === 'home';
        },
        isStory: function() {
            return this.get('album_type') === 'story';
        },
        isPosts: function() {
            return this.get('album_type') === 'posts';
        },
        isInfluencerCampaign: function() {
            return this.get('album_type') === 'influencer_campaign';
        },
    },
        // Class methods
        {
        getById: function(id) {
            var album = new Entities.Album({
                id: id
            });
            album.fetch();
            return album;
        }
    });
});
